import { IEvaluationContext } from "../IEvaluationContext";
import { AbsoluteModelPath } from "../../../../../../Common/ModelPath/ModelPath";
import { isNullOrEmpty } from "../../../../../../Common/TypingUtils";
import { ILocalizer, LocalizedString } from "../../Localization/ILocalizer";
import { MaskResolver } from "../../PathUtils/MaskResolver";

import { ValidationFunctionResult, ValidationFunctionResults, ValidationSeverity } from "./ValidationFunction";

export class DependenciesRequiredAreEmpty {
    private static readonly checkDependenciesAreEmpty = (
        context: IEvaluationContext,
        dependencies: AbsoluteModelPath[]
    ) =>
        dependencies.every(x => {
            const resolvedPath = context.resolvePath(x).toAbsolute();
            if (!resolvedPath.isResolved()) {
                return true;
            }
            const allResolvedPaths = MaskResolver.resolvePath(context.model, resolvedPath);
            for (const path of allResolvedPaths) {
                if (path.isContainCurrentIteration()) {
                    const allInstancesEmpty = Iterator.from(context.getAllResolvedValues(path.toEachIteration())).every(
                        isNullOrEmpty
                    );
                    if (!allInstancesEmpty) {
                        return false;
                    }
                } else {
                    const value = context.model.getValue(path);
                    if (!isNullOrEmpty(value)) {
                        return false;
                    }
                }
            }
            return true;
        });

    private static readonly checkValueNotEmpty = (context: IEvaluationContext, path: AbsoluteModelPath) =>
        Iterator.from(context.getAllResolvedValues(path)).some(v => !isNullOrEmpty(v));

    private static getMessage(localizer: ILocalizer, message: undefined | LocalizedString): undefined | string {
        if (message == undefined) {
            return undefined;
        }
        if (typeof message === "string") {
            return message;
        }
        return message(localizer);
    }

    public static execute(
        context: IEvaluationContext,
        path: AbsoluteModelPath,
        dependencies: AbsoluteModelPath[],
        message: LocalizedString | undefined,
        severity: ValidationSeverity,
        localization: ILocalizer
    ): ValidationFunctionResult {
        const isValid = this.checkValueNotEmpty(context, path) || this.checkDependenciesAreEmpty(context, dependencies);

        if (isValid) {
            return ValidationFunctionResults.Valid();
        } else {
            return ValidationFunctionResults.Invalid(
                this.getMessage(localization, message) ?? "Поле должно быть заполнено",
                severity
            );
        }
    }
}
